<template>
  <div id="inviate-box">
    <div class="nav">
      <img src="../../assets/nav/yz_nav_fh.png" class="fh" @click="goBack" />
      <p>邀请明细</p>
      <div class="right-nr">
        <div class="text"></div>
      </div>
    </div>

    <van-list
      v-model:loading="state.loading"
      :finished="state.finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell
        v-for="(item, i) in state.inviateList"
        :key="i + '-list'"
        :border="false"
      >
        <template #value>
          <span>{{ item.key }}</span>
          <ul class="inviate-data">
            <li v-for="data in item.items" :key="data.id">
              <p v-if="data.user_login">{{ data.user_login.slice(0, 3) }}***</p>
              <p v-else-if="data.mobile">
                {{
                  data.mobile.slice(0, 3) + "****" + data.mobile.slice(7, 11)
                }}
              </p>
              <p>邀请时间：{{ data.create_time }}</p>
            </li>
          </ul>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import { onActivated, onMounted, reactive } from "vue";
import { inviateDetail } from "../../api/yzuser.js";
import { getQueryString } from "@/utils/location";
export default {
  name: "inviateDetails",
  setup() {
    const state = reactive({
      msg: "5555",

      dataMonth: [],
      inviateList: [],
      uid: "",
      loading: false,
      finished: false,
    });

    onMounted(() => {
      onload();
    });

    var pagecode = 1;
    var totalpage = 1;
    const onLoad = () => {
      state.uid = localStorage.getItem("uid");
      let val = {
        // uid: state.uid,
        uid: getQueryString("uid"),
        pagecode: pagecode,
      };
      inviateDetail(val).then((response) => {
        console.log(response);

        if (response.data.code == 1) {
          totalpage = response.data.data.total_page;
          if (pagecode > response.data.data.total_page) {
            state.finished = true;
            return;
          }

          state.inviateList = state.inviateList.concat(
            response.data.data.lists
          );
          let month = state.inviateList;
          // console.log(month)
          let groupDate = month.reduce((groups, item) => {
            let date = new Date(item.create_time);
            // console.log(date)
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let ym = "" + year + "年" + month + "月";
            // console.log(year,month)
            if (!groups[ym]) {
              groups[ym] = [];
            }
            groups[ym].push(item);
            // console.log(groups)
            return groups;
          }, {});

          const groupedArray = Object.entries(groupDate).map(([key, items]) => {
            return { key, items };
          });

          state.dataMonth = groupDate;
          state.inviateList = groupedArray;
          console.log(groupedArray);
        } else {
          Toast(response.data.msg);
        }
        console.log(pagecode);
        pagecode++;
        state.loading = false;
      });
    };

    const goBack = () => {
      window.history.go(-1);
    };
    return {
      state,
      goBack,
      onLoad,
    };
  },
};
</script>
<style scoped>
#inviate-box {
  width: 100%;
  /* height: 100%; */
  min-height: 100vh;
  background-color: #f7f8fa;
  /* padding: 32px; */
  padding-top: 160px;
}

.nav {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 88px;
  width: 100%;
  position: fixed;
  top: 58px;
  z-index: 999;
  padding: 0 20px;
}
.nav .text {
  font-size: 30px;
  color: #664fc3;
}
.nav img {
  height: 50px;
  width: 50px;
  position: absolute;
  left: 20px;
}
.nav p {
  font-size: 32px;
  font-weight: 500;
  color: #333;
}

.van-cell {
  background-color: #f7f8fa;
}
.van-cell__value span {
  display: block;
  font-size: 28px;
  font-weight: 500;
  margin-bottom: 20px;
  color: #333;
}

.van-cell__value li {
  margin-bottom: 12px;
  font-size: 28px;
  font-weight: 500;
  background-color: #fff;
  height: 120px;
  border-radius: 16px;
  padding: 20px 24px;
}
.van-cell__value li p:nth-of-type(1) {
  font-size: 28px;
  font-weight: 500;
  color: #333;
}
.van-cell__value li p:nth-of-type(2) {
  font-size: 20px;
  color: #333;
}
</style>
